<template>
  <div class="create-com-size">
    <div class="breadcrumb" style="background: #fff">{{ title }}</div>
    <div class="order-detail-basic">
      <el-form hide-required-asterisk :model="createComSize" ref="createForm" :rules="createRules" label-width="130px">
        <el-form-item label="尺寸名称:" prop="sizeName">
          <el-input v-model="createComSize.sizeName" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="页面名称:" prop="sizeName" v-if="$route.query.id">
          <span v-show="!isChange">{{ asd.typeName }}</span>
          <el-form-item v-show="isChange" style="margin:0;float:left" label="" label-width="0" prop="choiceId">
            <el-select v-model="pageNameType.choiceId" @change="filterPageName">
              <el-option v-for="item in pageNameType.list" :key="item.id" :label="item.typeName" :value="item.typeCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="isChange" style="margin:0;float:left" label="" label-width="0" prop="asd">
            <el-select style="margin-left:10px" value-key="id" @change="selectPageName" v-model="asd">
              <el-option v-for="item in pageName.choicedPageNameList" :key="item.id" :label="item.typeName" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-button v-permission="'pts:admin:compose:size:update:page:name'" type="primary" style="margin-left:20px;" @click="changePage()" round>
            {{isChange?'确定':'变更'}}
          </el-button> -->
          <el-button v-if="isChange" v-permission="'pts:admin:compose:size:update:page:name'" type="primary" style="margin-left:20px;" @click="changePage()" round> {{ '确定' }} </el-button>
        </el-form-item>
        <el-form-item label="页面名称:" v-if="!$route.query.id">
          <el-form-item style="margin:0;float:left" label="" label-width="0" prop="choiceId">
            <el-select v-model="pageNameType.choiceId" @change="filterPageName">
              <el-option v-for="item in pageNameType.list" :key="item.id" :label="item.typeName" :value="item.typeCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin:0;float:left" label="" label-width="0" prop="asd">
            <el-select style="margin-left:10px" value-key="id" @change="selectPageName" v-model="asd">
              <el-option v-for="item in pageName.choicedPageNameList" :key="item.id" :label="item.typeName" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item label="匹配模板性质:">
          <span>{{ templateProperty }}</span>
        </el-form-item>
        <el-form-item label="宽高:">
          <el-form-item label="" style="margin:0;float:left" label-width="0" prop="sizeWidth">
            <el-input placeholder="" v-model="createComSize.sizeWidth" style="width:210px" @keydown.native="handleInput">
              <template slot="prepend">宽</template>
              <template slot="append">mm</template>
            </el-input>
          </el-form-item>
          <el-form-item label="" style="margin:0;float:left" label-width="0" prop="sizeHeight">
            <el-input placeholder="" v-model="createComSize.sizeHeight" style="width:210px" @keydown.native="handleInput">
              <template slot="prepend">高</template>
              <template slot="append">mm</template>
            </el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="出血类型:" prop="bleedId">
          <el-select clearable v-model="createComSize.bleedId">
            <el-option v-for="item in bleedType" :key="item.id" :label="item.bleedName" :value="item.id"> </el-option>
          </el-select>
          <el-button @click="addDialog = true" v-if="!$route.query.id" type="primary" style="margin: 0 0 10px 10px" round>新建出血类型</el-button>
        </el-form-item>
        <el-form-item label="出血:">
          <el-input placeholder="" v-model="bleedInfo.bleedTop" disabled style="width:210px;margin-bottom:10px;">
            <template slot="prepend">上方</template>
            <template slot="append">mm</template>
          </el-input>
          <el-input placeholder="" v-model="bleedInfo.bleedBottom" disabled style="width:210px;margin-bottom:10px;">
            <template slot="prepend">下方</template>
            <template slot="append">mm</template>
          </el-input>
          <el-input placeholder="" v-model="bleedInfo.bleedLeft" disabled style="width:210px;margin-bottom:10px;">
            <template slot="prepend">左侧</template>
            <template slot="append">mm</template>
          </el-input>
          <el-input placeholder="" v-model="bleedInfo.bleedRight" disabled style="width:210px;margin-bottom:10px;">
            <template slot="prepend">右侧</template>
            <template slot="append">mm</template>
          </el-input>
          <el-input placeholder="" v-model="bleedInfo.bleedIn" disabled style="width:210px;margin-bottom:10px;">
            <template slot="prepend">内侧</template>
            <template slot="append">mm</template>
          </el-input>
        </el-form-item>
        <el-form-item label="折线:">
          <el-table :data="HORIZONTAL" border style="width: 30%;float:left;margin-right:10px">
            <el-table-column label="水平折线" width="180">
              <template slot-scope="scope">
                <el-input style="width:80%;margin:0 auto" placeholder="" v-model="scope.row.brokenLineValue">
                  <template slot="append">mm</template>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span v-if="scope.$index !== HORIZONTAL.length - 1" @click="HORIZONTAL.splice(scope.$index, 1)" class="color-blue">删除</span>
                <span v-if="scope.$index === HORIZONTAL.length - 1" @click="addBrokenLine('HORIZONTAL', scope.row.brokenLineValue)" class="color-blue">添加</span>
              </template>
            </el-table-column>
          </el-table>
          <el-table border :data="VERTICAL" style="width: 30%">
            <el-table-column label="垂直折线" width="180">
              <template slot-scope="scope">
                <el-input style="width:80%;margin:0 auto" placeholder="" v-model="scope.row.brokenLineValue">
                  <template slot="append">mm</template>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span v-if="scope.$index !== VERTICAL.length - 1" @click="VERTICAL.splice(scope.$index, 1)" class="color-blue">删除</span>
                <span v-if="scope.$index === VERTICAL.length - 1" @click="addBrokenLine('VERTICAL', scope.row.brokenLineValue)" class="color-blue">添加</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="码:">
          <el-select v-model="barList.choiceBar" value-key="id">
            <el-option v-for="item in barList.allBarList" :key="item.id" :label="item.barName" :value="item"></el-option>
          </el-select>
          <el-button @click="addBar" type="primary" style="margin: 0 0 10px 10px" round>添加</el-button>
          <el-table border :data="barTableData" style="width: 80%">
            <el-table-column prop="barName" label="码名称"> </el-table-column>
            <el-table-column prop="name" label="码类型">
              <template slot-scope="scope"> {{ scope.row.codeType === 'BAR_CODE' ? '条形码' : scope.row.codeType === 'IDENTITY' ? '标识' : scope.row.codeType === 'QR_CODE' ? '二维码' : scope.row.codeType ===
                  'LOCKWIRE_BAR_CODE' ? '锁线条码' : scope.row.codeType === 'REMARK' ? '客户备注' : scope.row.codeType === 'VERTICAL_BAR_CODE' ? '上下条码' : scope.row.codeType === 'BLESSING_WALL_QR_CODE' ?
                    '祝福墙二维码' : '未定义字段'
              }} </template>
            </el-table-column>
            <el-table-column prop="address" label="码规格" width="300px">
              <template v-slot='scope'>
                <p style="fontSize:12px" v-if="scope.row.codeType !== 'IDENTITY'">宽度：{{ scope.row.width }}mm</p>
                <p style="fontSize:12px" v-if="scope.row.codeType !== 'IDENTITY'">高度：{{ scope.row.height }}mm</p>
                <p style=" fontSize:12px">{{ (scope.row.portrait === 'top' ? '距上：' : '距下：') + scope.row.portraitParam + 'mm' }}</p>
                <p style="fontSize:12px">{{ (scope.row.transverse === 'left' ? '距左：' : '距右：') + scope.row.transverseParam + 'mm' }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="操作">
              <template slot-scope="scope">
                <span class="color-blue" @click="barTableData.splice(scope.$index, 1)">移除</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button @click="onSubmit" round type="primary">保存</el-button>
    </div>
    <el-dialog :close-on-click-modal="false" title="新增出血类型" :visible.sync="addDialog" width="800px">
      <addhemorrhage v-if="addDialog" @end="end"></addhemorrhage>
    </el-dialog>
  </div>
</template>
<script>
import { pageTypeList, barList, pageNameList, composeSizeUpdatePage, composeTypeList, composeSizeUsable, bleedList, bleedDetail, composeSizeUpdate, composeSizeAdd, sizeDetail, cutUsable } from '@/api/pms'
import addhemorrhage from '../AddHemorrhage/index.vue'
export default {
  name: 'create-com-size',
  components: {
    addhemorrhage
  },
  data () {
    var checkPageType = (rule, value, callback) => {
      if (this.pageNameType.choiceId === '') {
        callback(new Error('请选择页面类型'))
      } else {
        callback()
      }
    }
    var checkChoiceId = (rule, value, callback) => {
      if (this.asd === '') {
        callback(new Error('请选择页面名称'))
      } else {
        callback()
      }
    }
    var checkSizeWidth = (rule, value, callback) => {
      if (this.createComSize.sizeWidth === '') {
        callback(new Error('请输入宽'))
        // !/^([0-9]+[\d]*(.[0-9]{1,2})?)$/.test(this.createComSize.sizeWidth) || 
      } else if (this.createComSize.sizeWidth < 0) {
        callback(new Error('只能输入大于等于0的值'))
      } else {
        callback()
      }
    }
    var checkSizeHeight = (rule, value, callback) => {
      if (this.createComSize.sizeHeight === '') {
        callback(new Error('请输入高'))
        // !/^([0-9]+[\d]*(.[0-9]{1,2})?)$/.test(this.createComSize.sizeHeight)
      } else if (this.createComSize.sizeHeight < 0) {
        callback(new Error('只能输入大于等于0的值'))
      } else {
        callback()
      }
    }
    var checkBar = (rule, value, callback) => {
      if (this.barTableData.length === 0) {
        callback(new Error('请添加码'))
      } else {
        callback()
      }
    }
    return {
      addDialog: false,
      isChange: false,
      title: '',
      tableData: [],
      barTableData: [],
      createComSize: {
        barCodeIdList: [],
        bleedId: '',
        pageNameId: '',
        brokenLineList: [],
        sizeDpi: '300',
        sizeHeight: '',
        sizeName: '',
        sizeWidth: ''
      },
      HORIZONTAL: [
        {
          brokenLineDirection: 'HORIZONTAL',
          brokenLineValue: ''
        }
      ],
      VERTICAL: [
        {
          brokenLineDirection: 'VERTICAL',
          brokenLineValue: ''
        }
      ],
      addNewName: '',
      sizeType: [],
      bleedType: [],
      bleedInfo: {},
      pageNameType: {
        list: [],
        choiceId: ''
      },
      pageName: {
        choicedPageNameList: [],
        allPageName: []
      },
      barList: {
        choiceBar: '',
        allBarList: []
      },
      asd: '',
      templateProperty: '',
      createRules: {
        sizeName: [
          { required: true, message: '请输入尺寸名称', trigger: 'blur' }
        ],
        choiceId: [
          { validator: checkPageType, trigger: 'change' }
        ],
        asd: [
          { validator: checkChoiceId, trigger: 'change' }
        ],
        sizeWidth: [
          { validator: checkSizeWidth, trigger: 'blur' }
        ],
        sizeHeight: [
          { validator: checkSizeHeight, trigger: 'blur' }
        ],
        bleedId: [
          { required: true, message: '请选择出血类型', trigger: 'change' }
        ]
        // bar: [
        //   { validator: checkBar, trigger: 'blur' }
        // ]
      }
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    this.title = this.$route.query.id ? '编辑尺寸' : '新建尺寸'
    this.getPageNameType()
    this.getPageName()
    this.getBarList()
    this.getHemType()
    // setTimeout(_ => {
    //   this.$route.query.id && this.getSizeMsg()
    // }, 1)
  },
  watch: {
    'createComSize.bleedId': function () {
      this.getBleed()
    }
  },
  methods: {
    handleInput (e) {
      // 通过正则过滤小数点后两位
      e.target.value = (e.target.value.match(/^\d*(\.?\d{0,1})/g)[0]) || null
    },
    end (name) {
      this.addNewName = name
      this.addDialog = false
      this.getHemType()
    },
    changePage () {
      if (!this.isChange) {
        this.isChange = true
      } else {
        if (!this.asd) {
          return
        }
        composeSizeUpdatePage({ sizeId: this.$route.query.id, pageNameId: this.asd.id }).then(res => {
          if (res.data.success) {
            this.$message.success('修改成功')
            this.isChange = false
          }
        })
      }
    },
    addBrokenLine (type, val) {
      if (val === '') {
        this.$message.error('请输入值')
        return
      }
      if (type === 'VERTICAL') {
        this.VERTICAL.push({ brokenLineDirection: 'VERTICAL', brokenLineValue: '' })
      } else if (type === 'HORIZONTAL') {
        this.HORIZONTAL.push({ brokenLineDirection: 'HORIZONTAL', brokenLineValue: '' })
      }
    },
    getSizeMsg () {
      sizeDetail(this.$route.query.id).then(res => {
        if (res.data.success) {
          this.createComSize = {
            barCodeIdList: [],
            bleedId: '',
            pageNameId: '',
            brokenLineList: [],
            sizeDpi: '300',
            sizeHeight: res.data.data.sizeHeight,
            sizeName: res.data.data.sizeName,
            sizeWidth: res.data.data.sizeWidth
          }
          this.pageNameType.choiceId = res.data.data.spuPageName.pageTypeCode
          this.filterPageName()
          this.asd = res.data.data.spuPageName
          this.selectPageName(this.asd)
          this.createComSize.bleedId = res.data.data.bleed.id
          this.barTableData = res.data.data.barCodeList
          res.data.data.composeSizeBrokenLineXrefList.forEach(item => {
            if (item.brokenLineDirection === 'HORIZONTAL') {
              this.HORIZONTAL.unshift(item)
            } else if (item.brokenLineDirection === 'VERTICAL') {
              this.VERTICAL.unshift(item)
            }
          })
        }
      })
    },
    selectPageName (val) {
      this.createComSize.pageNameId = val.id
      this.templateProperty = val.templateProperty
    },
    // 保存
    onSubmit () {
      this.$refs.createForm.validate((valid) => {
        if (!valid) {
          return
        }
        let HORIZONTAL = this.HORIZONTAL[this.HORIZONTAL.length - 1].brokenLineValue === '' ? this.HORIZONTAL.slice(0, -1) : this.HORIZONTAL
        let VERTICAL = this.VERTICAL[this.VERTICAL.length - 1].brokenLineValue === '' ? this.VERTICAL.slice(0, -1) : this.VERTICAL
        this.createComSize.brokenLineList = [...HORIZONTAL, ...VERTICAL]
        if (
          this.createComSize.brokenLineList.some(item => { return /[^\d]/g.test(item.brokenLineValue) })
        ) {
          this.$message.error('折线值只能为正整数')
          return
        }
        let barCodeIdList = []
        this.barTableData.forEach(item => {
          barCodeIdList.push(item.id)
        })
        this.createComSize.barCodeIdList = barCodeIdList
        if (this.$route.query.id) {
          composeSizeUsable({
            act: 1,
            sizeId: this.$route.query.id,
            sizeName: this.createComSize.sizeName
          }).then((res) => {
            if (res.data.success) {
              composeSizeUpdate({ sizeId: this.$route.query.id, composeSizeVo: this.createComSize }).then((res) => {
                if (res.data.success) {
                  this.$message.success('编辑尺寸成功')
                  this.$router.push('./sizeGroupAdmin')
                }
              })
            }
          })
        } else {
          composeSizeUsable({
            act: 0,
            sizeId: '',
            sizeName: this.createComSize.sizeName
          }).then((res) => {
            if (res.data.success) {
              composeSizeAdd(this.createComSize).then((res) => {
                if (res.data.success) {
                  this.$message.success('新建尺寸成功')
                  this.$router.push('./sizeGroupAdmin')
                }
              })
            }
          })
        }
      })
    },
    // 移出码
    deleteBar (row) {
      console.log('row', row.index)
      this.barTableData.splice(row.$index, 1)
    },
    // 添加条码
    addBar () {
      if (this.barList.choiceBar === '') {
        this.$message.error('未选择码')
        return
      }
      this.barTableData.push(this.barList.choiceBar)
    },
    // 获取条码列表(后期应该会分类，先选择条形码或者二维码)
    getBarList () {
      barList().then(res => {
        if (res.data.success) {
          this.barList.allBarList = res.data.data
        }
      })
    },
    // 筛选出该页面类别下的页面名称
    filterPageName () {
      this.pageName.choicedPageNameList = this.pageName.allPageName.filter(item => {
        if (item.pageTypeCode === this.pageNameType.choiceId) {
          return true
        }
      })
      this.asd = ''
    },
    // 获取所有页面名称
    getPageName () {
      pageNameList().then(res => {
        if (res.data.success) {
          this.pageName.allPageName = res.data.data
          this.$route.query.id && this.getSizeMsg()
        }
      })
    },
    // 获取页面类型
    getPageNameType () {
      pageTypeList().then(res => {
        if (res.data.success) {
          this.pageNameType.list = res.data.data
        }
      })
    },
    // -------------------------------------------------------
    getComSize () {
      composeTypeList().then((res) => {
        if (res.data.success) {
          this.sizeType = res.data.data
        } else {
        }
      })
    },
    // 获取出血类型
    getHemType () {
      bleedList().then((res) => {
        if (res.data.success) {
          this.bleedType = res.data.data
          if (this.addNewName) {
            res.data.data.forEach(item => {
              if (item.bleedName === this.addNewName) {
                this.createComSize.bleedId = item.id
              }
            })
          }
        }
      })
    },
    getBleed () {
      bleedDetail(this.createComSize.bleedId).then((res) => {
        if (res.data.success) {
          this.bleedInfo = res.data.data
        }
      })
    },
    getSizeInfo () {
      sizeDetail(this.$route.query.id).then((res) => {
        if (res.data.success) {
          this.createComSize = res.data.data
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.create-com-size {
  .spec-mm {
    span {
      margin-right: 10px;
    }

    .el-input {
      width: auto;

      @{deep} .el-input__inner {
        width: 65px;
      }
    }

    @{deep} .el-input-group__append {
      padding: 0 15px;
    }
  }
}
</style>
